export const GET_TRANSFER_OPTION_REQUEST = 'GET_TRANSFER_OPTION_REQUEST';
export const GET_TRANSFER_OPTION_SUCCESS = 'GET_TRANSFER_OPTION_SUCCESS';
export const GET_TRANSFER_OPTION_FAILURE = 'GET_TRANSFER_OPTION_FAILURE';

export const GET_TRANSFER_LINE_STORE_REQUEST = 'GET_TRANSFER_LINE_STORE_REQUEST';
export const GET_TRANSFER_LINE_RESET_REQUEST = 'GET_TRANSFER_LINE_RESET_REQUEST';

export const GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST = 'GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST';
export const GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS = 'GET_TRANSFER_LINE_DETAIL_INSTRUCTION_SUCCESS';
export const GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE = 'GET_TRANSFER_LINE_DETAIL_INSTRUCTION_FAILURE';

export const TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST = 'TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST';
export const TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS = 'TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_SUCCESS';
export const TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE = 'TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_FAILURE';

export const TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST = 'TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST';
export const TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS = 'TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_SUCCESS';
export const TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE = 'TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_FAILURE';

export const TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST = 'TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST';
export const TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS = 'TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_SUCCESS';
export const TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE = 'TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_FAILURE';

export const GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST = 'GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST';
export const GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS = 'GET_TRANSFER_LINE_ORDER_SUBMIT_SUCCESS';
export const GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE = 'GET_TRANSFER_LINE_ORDER_SUBMIT_FAILURE';

export const GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST = 'GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST';
export const GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS = 'GET_TRANSFER_LINE_PERSONAL_PLANS_SUCCESS';
export const GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE = 'GET_TRANSFER_LINE_PERSONAL_PLANS_FAILURE';
